import { curEnvConfigAppInfoDict } from './config'

// qiankun-like config
export const MICRO_APP_CONFIG = [
  {
    type: 'iframe', // iframe qiankun
    container: '#s-viewport-iframe',
    activeRule: '/s/bi',
    name: 'scb-front', // app name registered
    entry: curEnvConfigAppInfoDict.bi.entry, // https://bi.qizhishangke.com
    hiddenType: 'display', // 隐藏一个页签的时候, 使用display: none, render-tree 不渲染, 推荐使用
    ignoreLogoutReq: true, // 忽略子应用的登出请求
  },
  // {
  //   type: 'qiankun', // iframe qiankun
  //   container: '#s-viewport',
  //   activeRule: '/s/bi',
  //   name: 'scb-front', // app name registered
  //   entry: 'http://localhost:9000',
  // },
  {
    type: 'iframe',
    container: '#s-viewport-iframe',
    activeRule: '/s/erp',
    name: 'erp', // app name registered
    entry: curEnvConfigAppInfoDict.erp.entry,
    hiddenType: 'position', // 隐藏一个页签的时候, 使用position: fixed, 放在可视区域之外
    ignoreLogoutReq: false, // 忽略子应用的登出请求
  },
]
